import { Capacitor } from '@capacitor/core'

// True when running as an installed app: a Capacitor native build or a
// home-screen PWA (standalone display mode; legacy navigator.standalone on
// iOS Safari). Installed apps are the tournament app — they never show the
// public marketing homepage or the merch store in their navigation.
export function isInstalledApp() {
  if (Capacitor.isNativePlatform()) return true
  if (typeof window === 'undefined') return false
  return (
    window.matchMedia?.('(display-mode: standalone)')?.matches === true ||
    window.navigator.standalone === true
  )
}
